<template>
    <div>
        <input @change="fileChange" :key="fileRefKey" :accept="acceptFileType" style="display: none" type="file" :ref="attachmentId">
    </div>
</template>

<script>

    export default {
        props: {
            acceptFileType: {
                type: String,
                default: '.pdf,.PDF,.doc,.DOC,.docx,.DOCX,.xls,.XLS,.xlsx,.XLSX,.png,.PNG,.jpg,.JPG,.jpeg,.JPEG,.bmp,.BMP'
            },
        },
        components: {

        },
        data() {
            return {
                fileRefKey:Math.random(),
                attachmentId: 'attachment' + new Date().getTime(),
            }
        },
        created(){

        },
        methods: {
            selectFileClick(){
                this.$refs[this.attachmentId].click()
            },
            fileChange() {
                var that = this;
                let AllupExt = this.acceptFileType;
                let fileName = this.$refs[that.attachmentId].files[0].name;
                let extName = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
                if (AllupExt.indexOf(extName.replace('.','')) == '-1') {
                    this.$alert(`文件格式不正确，只支持上传【${AllupExt}】类型的文件，请重新上传`, '警告', {
                        confirmButtonText: '确定',
                    })
                    return;
                }
                let fd = new FormData();
                fd.append('file1', this.$refs[that.attachmentId].files[0]);
                fd.append('table', 'xlsFile');
                this.formLoading = true;
                this.$http.post('/uploadpublicFile.do', fd,{baseURL: '/sso'}).then(res => {
                    if (res.data.code == "1" && res.data.filepath) {
                        res.data.fileName = fileName;
                        res.data.filePath = res.data.filepath;
                        this.$emit('uploadSuccess',res.data)
                        this.fileRefKey = Math.random();
                        this.formLoading = false;
                    }else{
                        this.$message.error('上传失败，请重新上传');
                    }
                })
            },
        }


    }
</script>